module.exports = __webpack_public_path__ + "static/media/hiso-bus-rental-logo-ไฮโซบัสขรถบัสเช่า-โลโก้-ฟ้าส้ม-ข้อความ.f1000160.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hiso-bus-rental-logo-ไฮโซบัสขรถบัสเช่า-โลโก้-ฟ้าส้ม-ข้อความ.jpg
// module id = 196
// module chunks = 57